<template>
  <span>
    <div
      @click="() => onHandlerSubmit(item)"
      class="LbxpaC"
      v-for="(item, idx) in value.containers"
      :key="idx"
    >
      <div class="J9alP4">
        <span>{{ item.number }}</span
        ><svg
          width="20"
          height="20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          :class="`ubJc5M ${idShow == item.number ? 'wcPNG_' : ''}`"
        >
          <path
            d="m8.929 14 3.901-3.929L8.901 6.17"
            stroke="#000C37"
            stroke-width="1.8"
            stroke-linecap="round"
          ></path>
        </svg>
      </div>
      <div v-if="idShow == item.number" class="ZvlSEi" style="height: auto">
        <Router v-model="dataRouter" />
      </div>
    </div>
  </span>
</template>

<script>
import moment from "moment";
import Router from "./Router.vue";

export default {
  props: {
    value: {
      type: Object,
      default: () => [],
    },
  },
  components: {
    Router,
  },

  data() {
    return {
      moment,
      idShow: "",
      dataRouter: [],
    };
  },
  methods: {
    onHandlerSubmit(item) {
      if (this.idShow === item.number) {
        this.idShow = "";
        this.dataRouter = [];
        return;
      }
      this.idShow = item.number;
      this.createdTreeRoute(item.events);
    },
    createdTreeRoute(events) {
      /* 1  group location   */
      const group_location = events.reduce((acc, cur) => {
        const { location } = cur;
        if (!acc[location]) {
          acc[location] = [];
        }
        acc[location].push(cur);
        return acc;
      }, {});
      /* 2  group_location find location == id của locations group child   */
      const tree = [];
      for (const [key, value] of Object.entries(group_location)) {
        const numericKey = Number(key);
        const parent = this.value.locations.find(
          (item) => item.id === numericKey
        );

        if (parent) {
          tree.push({
            ...parent,
            children: value,
          });
        }
      }
      this.dataRouter = tree;
    },
  },
};
</script>
